import { useSheets } from '../state/sheets';
import { TaskSheet } from '../features/board/TaskSheet';
import { WaitingSheet, WipSheet } from '../features/board/SmallSheets';
import { SettingsSheet } from '../features/settings/SettingsSheet';
import { PeopleSheet } from '../features/settings/PeopleSheet';
import { RoutineSheet } from '../features/routines/RoutineSheet';
import { EventSheet } from '../features/agenda/EventSheet';
import { ImportMapSheet } from '../features/orgmap/ImportMapSheet';
import { ClaudeAccessSheet } from '../features/settings/ClaudeAccessSheet';
import { NotificationsSheet } from '../features/notifications/NotificationsSheet';
import { TeamsSheet } from '../features/notifications/TeamsSheet';
import { TemplatesSheet } from '../features/templates/TemplatesSheet';

/** Renderiza a folha modal pedida via openSheet(). */
export function SheetHost() {
  const s = useSheets(x => x.current);
  if (!s) return null;
  switch (s.kind) {
    case 'task': return <TaskSheet key={s.id} id={s.id} />;
    case 'waiting': return <WaitingSheet title={s.title} onConfirm={s.onConfirm} />;
    case 'wip': return <WipSheet />;
    case 'settings': return <SettingsSheet tab={s.tab} />;
    case 'people': return <PeopleSheet />;
    case 'routine': return <RoutineSheet key={s.id ?? 'new'} id={s.id} />;
    case 'event': return <EventSheet key={s.id ?? 'new'} id={s.id} preset={s.preset} />;
    case 'map-import': return <ImportMapSheet />;
    case 'claude': return <ClaudeAccessSheet />;
    case 'notifications': return <NotificationsSheet />;
    case 'teams': return <TeamsSheet />;
    case 'templates': return <TemplatesSheet key={`${s.edit}-${s.fromTask}`} edit={s.edit} fromTask={s.fromTask} />;
  }
}
